import Vue from 'vue'
import 'weui'
import App from './App.vue'
import router from './route/router'
import store from './store/index.js'
import wx from 'weixin-js-sdk'
import viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import {Checkbox, Button, Cell, CellGroup, ActionSheet, RadioGroup, Radio, Form, Field, Uploader, Icon, Swipe, SwipeItem, Tag, Image as VanImage, PasswordInput, Dialog  } from 'vant'
global.wx = wx

Vue.use(Checkbox)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(ActionSheet)
Vue.use(Field)
Vue.use(Form)
Vue.use(Uploader)
Vue.use(Icon)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tag)
Vue.use(VanImage)
Vue.use(PasswordInput)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Dialog)

Vue.use(viewer)
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
new Vue({
  router,
  store,
  viewer,
  render: h => h(App)
}).$mount('#app')
